import BaseStore from './BaseStore'

export class ActiveDirectoryStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'active_directories'
  }
}

export default new ActiveDirectoryStore()


// WEBPACK FOOTER //
// ./src/stores/ActiveDirectoryStore.js